import { useState, useRef, useEffect } from 'react';

import { useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';

// material-ui
import { useTheme } from '@mui/material/styles';
import {
    Avatar,
    Box,
    Chip,
    ClickAwayListener,
    Divider,
    Grid,
    InputAdornment,
    List,
    ListItemButton,
    ListItemIcon,
    ListItemText,
    OutlinedInput,
    Paper,
    Popper,
    Stack,
    Typography,
    Button,
    Grow,
    AppBar,
    Toolbar,
    IconButton,
    Dialog,
    DialogActions,
    DialogContent,
    DialogContentText,
    Icon,
    Badge
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
// third-party
import PerfectScrollbar from 'react-perfect-scrollbar';

// project imports
import MainCard from 'ui-component/cards/MainCard';
import Transitions from 'ui-component/extended/Transitions';
import UpgradePlanCard from './UpgradePlanCard';
import User1 from 'assets/images/users/user-round.svg';
import { logoutUser, resetMultipleCompanies } from 'store/login/loginactions';
import SwitchCompanyModal from './SwitchCompanyModal';
import { setCustomerUserPermissionLevel } from 'store/login/loginactions';

// assets
import { IconLogout, IconSearch, IconSettings, IconUser, IconBell } from '@tabler/icons-react';
import EmailWIthGmailService from '../../../../views/settings/NotificationProvider/gmail/EmailWIthGmailService';
import { useLocation } from 'react-router-dom';
import DefaultSettingService from 'views/settings/General/default/DefaultSettingService';
import { getSocket } from '../../../../Socket';
import ThemeSwitcher from '../../../../themes/ThemeSwitcher';

// ==============================|| PROFILE MENU ||============================== //

const ProfileSection = () => {
    const theme = useTheme();
    const location = useLocation();
    const socket = getSocket();

    const dispatch = useDispatch();
    const customization = useSelector((state) => state.customization);
    const userDetail = useSelector((state) => state.login.userDetail);
    const navigate = useNavigate();
    const avatarChar = userDetail.email?.charAt(0).toUpperCase();

    const [sdm, setSdm] = useState(true);
    const [value, setValue] = useState('');
    const [notification, setNotification] = useState(false);
    const [selectedIndex, setSelectedIndex] = useState(-1);
    const [open, setOpen] = useState(false);
    const [notificationPopupOpen, setNotificationPopupOpen] = useState(false);

    const [openSwitchCompanyDialog, setOpenSwitchCompanyDialog] = useState(false);
    const [emailConfig, setEmailConfig] = useState({});
    /**
     * anchorRef is used on different componets and specifying one type leads to other components throwing an error
     * */
    const anchorRef = useRef(null);
    const handleLogout = async () => {
        // console.log('Logout');
        // dispatch(removeFcmToken());

        dispatch(logoutUser());
    };

    const handleClose = (event) => {
        if (anchorRef.current && anchorRef.current.contains(event.target)) {
            return;
        }
        setOpen(false);
    };

    const handleListItemClick = (event, index, route = '') => {
        setSelectedIndex(index);
        handleClose(event);

        if (route && route !== '') {
            navigate(route);
        }
    };
    const handleToggle = () => {
        // console.log('####=handleToggle');
        setOpen((prevOpen) => !prevOpen);
    };

    const handleNotificationToggle = () => {
        // console.log('####=handleToggle');
        setNotificationPopupOpen((prevState) => !prevState);
    };

    const prevOpen = useRef(open);
    useEffect(() => {
        if (prevOpen.current === true && open === false) {
            anchorRef.current.focus();
        }

        prevOpen.current = open;
    }, [open]);

    const handleOpenSwitchCompanyDialog = (pollingIntervalId) => {
        setOpenSwitchCompanyDialog(true);
    };

    const handleCloseSwitchCompanyDialog = () => {
        setOpenSwitchCompanyDialog(false);
    };
    const handleFetchEmail = async () => {
        if (socket) {
            let socketTopic = userDetail.clientUserId + '-User';

            socket.emit('subscribe', socketTopic);
            socket.on(socketTopic, (socketResponseData) => {
                if (socketResponseData === 'LOGOUT') {
                    handleLogout();
                }
            });
        }
        await EmailWIthGmailService.getEmailWithGmailMaster()
            .then(({ data }) => {
                setEmailConfig(data.data);
            })
            .catch((err) => {
                // setLoading(false);
            });
    };
    const handleFetchCustomerUserPermission = async () => {
        await DefaultSettingService.getAppConfigByConfigKey('pLevlToAddCustomerUser')
            .then(({ data }) => {
                dispatch(setCustomerUserPermissionLevel(data.data.value));
                // setEmailConfig(data.data);
            })
            .catch((err) => {
                // setLoading(false);
            });
    };

    useEffect(() => {
        handleFetchEmail();
        if (userDetail.isCustomerUser) {
            handleFetchCustomerUserPermission();
        }
    }, [location]);

    return (
        <>
            <Badge
                overlap="circular"
                variant="dot"
                color="error"
                invisible={!emailConfig?.syncFailed}
                anchorOrigin={{
                    vertical: 'top',
                    horizontal: 'right'
                }}
            >
                <Icon
                    sx={{
                        justifyContent: 'center',
                        borderRadius: '27px',
                        transition: 'all .2s ease-in-out',
                        borderColor: theme.palette.primary.light,
                        backgroundColor: theme.palette.primary.light,
                        marginRight: '15px',
                        '&[aria-controls="menu-list-grow"], &:hover': {
                            borderColor: theme.palette.primary.main,
                            background: `${theme.palette.primary.main}!important`,
                            color: theme.palette.primary.light,
                            '& svg': {
                                stroke: theme.palette.primary.light
                            }
                        }
                    }}
                    aria-controls={notificationPopupOpen ? 'menu-list-grow' : undefined}
                    aria-haspopup="true"
                    onClick={handleNotificationToggle}
                >
                    <IconBell stroke={1.5} style={{ marginRight: 10 }} size="1.5rem" color={theme.palette.primary.main} />
                </Icon>
            </Badge>
            <Chip
                sx={{
                    height: '48px',
                    alignItems: 'center',
                    borderRadius: '27px',
                    transition: 'all .2s ease-in-out',
                    borderColor: theme.palette.primary.light,
                    backgroundColor: theme.palette.primary.light,
                    '&[aria-controls="menu-list-grow"], &:hover': {
                        borderColor: theme.palette.primary.main,
                        background: `${theme.palette.primary.main}!important`,
                        color: theme.palette.primary.light,
                        '& svg': {
                            stroke: theme.palette.primary.light
                        }
                    },
                    '& .MuiChip-label': {
                        lineHeight: 0
                    }
                }}
                icon={
                    <Avatar
                        //src={User1}
                        sx={{
                            ...theme.typography.mediumAvatar,
                            margin: '8px 0 8px 8px !important',
                            cursor: 'pointer'
                        }}
                        ref={anchorRef}
                        aria-controls={open ? 'menu-list-grow' : undefined}
                        aria-haspopup="true"
                        color="inherit"
                    >
                        {avatarChar}
                    </Avatar>
                }
                label={<IconSettings stroke={1.5} size="1.5rem" color={theme.palette.primary.main} />}
                variant="outlined"
                ref={anchorRef}
                aria-controls={open ? 'menu-list-grow' : undefined}
                aria-haspopup="true"
                onClick={handleToggle}
                color="primary"
            />
            <Popper
                id="menu-list-grow"
                placement="bottom-end"
                open={open}
                anchorEl={anchorRef.current}
                role={undefined}
                transition
                disablePortal
                modifiers={[
                    {
                        name: 'offset',
                        options: {
                            offset: [0, 14]
                        }
                    }
                ]}
                // popperOptions={{
                //     modifiers: [
                //         {
                //             name: 'offset',
                //             options: {
                //                 offset: [0, 14]
                //             }
                //         }
                //     ]
                // }}
            >
                {({ TransitionProps }) => (
                    <Transitions in={open} {...TransitionProps}>
                        {console.log('Popper rendering, open:', open)}
                        <Paper>
                            <ClickAwayListener onClickAway={handleClose}>
                                <MainCard border={false} elevation={16} content={false} boxShadow shadow={theme.shadows[16]}>
                                    <Box sx={{ paddingTop: 2, paddingLeft: 2, paddingRight: 2 }}>
                                        <Stack>
                                            <Stack direction="row" spacing={0.5} alignItems="center">
                                                <Typography component="span" variant="h4" sx={{ fontWeight: 400 }}>
                                                    {userDetail && userDetail.email ? userDetail && userDetail.email : ''}
                                                </Typography>
                                            </Stack>
                                            <Typography variant="subtitle2">
                                                {userDetail && userDetail.clientName ? userDetail && userDetail.clientName : ''}
                                            </Typography>
                                        </Stack>
                                        <Divider />
                                    </Box>
                                    <PerfectScrollbar style={{ height: '100%', maxHeight: 'calc(100vh - 250px)', overflowX: 'hidden' }}>
                                        <Box sx={{ p: 0 }}>
                                            <List
                                                component="nav"
                                                sx={{
                                                    width: '100%',
                                                    maxWidth: 350,
                                                    minWidth: 300,
                                                    backgroundColor: theme.palette.background.paper,
                                                    borderRadius: '10px',
                                                    [theme.breakpoints.down('md')]: {
                                                        minWidth: '100%'
                                                    },
                                                    '& .MuiListItemButton-root': {
                                                        mt: 0.5
                                                    }
                                                }}
                                            >
                                                <ListItemButton
                                                    sx={{ borderRadius: `${customization.borderRadius}px` }}
                                                    // selected={selectedIndex === 0}
                                                    onClick={handleOpenSwitchCompanyDialog}
                                                >
                                                    <ListItemIcon>
                                                        <IconSettings stroke={1.5} size="1.3rem" />
                                                    </ListItemIcon>
                                                    <ListItemText primary={<Typography variant="body2">Change Company</Typography>} />
                                                </ListItemButton>
                                                <ListItemButton
                                                    sx={{ borderRadius: `${customization.borderRadius}px` }}
                                                    // selected={selectedIndex === 0}
                                                    onClick={handleLogout}
                                                >
                                                    <ListItemIcon>
                                                        <IconLogout stroke={1.5} size="1.3rem" />
                                                    </ListItemIcon>
                                                    <ListItemText primary={<Typography variant="body2">Logout</Typography>} />
                                                </ListItemButton>
                                            </List>
                                        </Box>
                                    </PerfectScrollbar>
                                </MainCard>
                            </ClickAwayListener>
                        </Paper>
                    </Transitions>
                )}
            </Popper>

            <Popper
                id="menu-list-grow"
                placement="bottom-end"
                open={notificationPopupOpen}
                anchorEl={anchorRef.current}
                role={undefined}
                transition
                disablePortal
                modifiers={[
                    {
                        name: 'offset',
                        options: {
                            offset: [0, 14]
                        }
                    }
                ]}
                // popperOptions={{
                //     modifiers: [
                //         {
                //             name: 'offset',
                //             options: {
                //                 offset: [0, 14]
                //             }
                //         }
                //     ]
                // }}
            >
                {({ TransitionProps }) => (
                    <Transitions in={notificationPopupOpen} {...TransitionProps}>
                        <Paper>
                            <ClickAwayListener
                                onClickAway={() => {
                                    setNotificationPopupOpen(false);
                                }}
                            >
                                <MainCard border={false} elevation={16} content={false} boxShadow shadow={theme.shadows[16]}>
                                    <Box sx={{ paddingTop: 2, paddingLeft: 2, paddingRight: 2 }}>
                                        {emailConfig.syncFailed ? (
                                            <Typography variant="body2" color="primary" component="div">
                                                <strong>Please configure your account to send emails.</strong>
                                            </Typography>
                                        ) : (
                                            <Typography variant="body2" color="#c 5c5c5" component="div">
                                                <strong>No notification found.</strong>
                                            </Typography>
                                        )}

                                        <Box
                                            sx={{
                                                display: 'flex',
                                                alignItems: 'center',
                                                justifyContent: 'space-between',
                                                width: '100%'
                                            }}
                                        >
                                            <Box>My Header</Box>

                                            <ThemeSwitcher />
                                        </Box>
                                    </Box>
                                </MainCard>
                            </ClickAwayListener>
                        </Paper>
                    </Transitions>
                )}
            </Popper>

            {/* Switch Company Modal Start from here */}
            <Dialog
                open={openSwitchCompanyDialog}
                onClose={handleCloseSwitchCompanyDialog}
                TransitionComponent={Grow}
                TransitionProps={{ direction: 'up', timeout: 500 }}
                maxWidth="lg" // set the maximum width of the dialog
            >
                {/* <DialogTitle>Confirm Delete</DialogTitle> */}
                <AppBar color="inherit" sx={{ position: 'relative', height: '48px', background: theme.palette.secondary.light }}>
                    <Toolbar>
                        <Typography
                            edge="start"
                            sx={{
                                flex: 1,
                                fontSize: '0.875rem',
                                fontWeight: 500,
                                color: theme.palette.secondary.main,
                                textTransform: 'capitalize',
                                marginTop: '10px'
                            }}
                            variant="caption"
                            component="div"
                        >
                            Change Company
                        </Typography>

                        <IconButton color="inherit" onClick={handleCloseSwitchCompanyDialog} aria-label="close">
                            <CloseIcon />
                        </IconButton>
                    </Toolbar>
                </AppBar>
                <SwitchCompanyModal
                    handleModalClose={() => {
                        // console.log('###handleModalClose');
                        handleCloseSwitchCompanyDialog();
                    }}
                />
                <DialogActions sx={{ backgroundColor: theme.palette.secondary.light }}>
                    <Button variant="outlined" onClick={handleCloseSwitchCompanyDialog}>
                        Cancel
                    </Button>
                    {/* <Button variant="contained" onClick={handleCloseSwitchCompanyDialog}>
                        Save
                    </Button> */}
                </DialogActions>
            </Dialog>
            {/*  Switch Company Modal End  here */}
        </>
    );
};

export default ProfileSection;
